import React from 'react'
import { View, StyleSheet, TouchableOpacity, Dimensions, Linking } from 'react-native'
import Colors from '../../constants/Colors'
import { Text } from '../Themed'
import { useAppSelector } from '../../state/hooks'
import { getCurrentOrgDayHours } from '../../helpers/restaurantHours'
import { CHECKOUT_FOOTER_HEIGHT, SMALL_WIDTH } from '../../constants/GlobalStyle'

const CopyrightFooter = ({ showIcons = null }) => {
	const { loadedData } = useAppSelector(state => state.data)
	const { appDisplayOptions } = useAppSelector(state => state.settings)
	const { showDisclaimerText } = appDisplayOptions
	const overMaxWidth = Dimensions.get('window').width > 1200
	const screenWidth = overMaxWidth ? 1200 : Dimensions.get('window').width * 0.9
	const currentYear = new Date().getFullYear()
	const orgName = loadedData[global.org].name.toUpperCase()
	const orgAddress = loadedData[global.org].address.toUpperCase()
	const orgHours = loadedData[global.org].hours
	const iconText = showIcons && showDisclaimerText ? ' | ICONS BY FREEPIK' : ''

	return (
		<View style={[styles.footerContainer, { height: CHECKOUT_FOOTER_HEIGHT }]}>
			<View
				style={{
					width: screenWidth,
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				{/* Location Information */}
				{global.org === 'clubkitchen' && (
					<View style={styles.locationContainer}>
						<Text style={styles.locationName}>{orgName}</Text>
						<Text style={styles.addressText}>{orgAddress}</Text>
						{/* <Text
							style={styles.hoursText}
						>{`TODAY'S HOURS: ${getCurrentOrgDayHours(orgHours)}`}</Text> */}
					</View>
				)}
				{SMALL_WIDTH ? (
					<>
						<View style={styles.copyrightContainer}>
							<Text style={styles.footerText}>{`© ${currentYear} ${orgName}${iconText}`}</Text>
						</View>
						<View style={[styles.copyrightContainer, { marginTop: 5 }]}>
							<View style={styles.linkContainer}>
								<TouchableOpacity onPress={() => Linking.openURL('https://nextgenkitchens.com/')}>
									<Text style={styles.linkText}>POWERED BY NEXTGEN KITCHENS</Text>
								</TouchableOpacity>
							</View>
							<View style={styles.linkContainer}>
								<TouchableOpacity
									onPress={() => {
										window.open('/privacy-policy', '_blank')
									}}
								>
									<Text style={styles.linkText}>PRIVACY POLICY</Text>
								</TouchableOpacity>
							</View>
						</View>
					</>
				) : (
					<>
						<View style={styles.copyrightContainer}>
							<Text style={styles.footerText}>{`© ${currentYear} ${orgName}${iconText}`}</Text>
							<View style={styles.linkContainer}>
								<TouchableOpacity onPress={() => Linking.openURL('https://nextgenkitchens.com/')}>
									<Text style={styles.linkText}>POWERED BY NEXTGEN KITCHENS</Text>
								</TouchableOpacity>
							</View>
							<View style={styles.linkContainer}>
								<TouchableOpacity
									onPress={() => {
										window.open('/privacy-policy', '_blank')
									}}
								>
									<Text style={styles.linkText}>PRIVACY POLICY</Text>
								</TouchableOpacity>
							</View>
						</View>
					</>
				)}
				{/* Copyright and Links */}
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	footerContainer: {
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#333',
		height: 80,
		borderTopColor: Colors.greyscale[5],
		borderTopWidth: 0.25,
	},
	locationContainer: {
		alignItems: 'flex-start',
		alignSelf: 'flex-start',
		marginBottom: 15,
	},
	locationName: {
		color: Colors.greyscale[7],
		fontSize: 16,
		fontWeight: 'bold',
		marginBottom: 5,
	},
	addressText: {
		color: Colors.greyscale[7],
		fontSize: 14,
		marginBottom: 5,
	},
	hoursText: {
		color: Colors.greyscale[7],
		fontSize: 14,
	},
	copyrightContainer: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
	},
	footerText: {
		color: Colors.greyscale[7],
		fontSize: 12,
	},
	linkContainer: {
		flexDirection: 'row',
		gap: 30,
		marginRight: 10,
	},
	linkText: {
		color: Colors.greyscale[7],
		fontSize: 12,
	},
})

export default CopyrightFooter
